import { KEY_NAMES } from 'app/providers/keyNames';
import React, { FC, PropsWithChildren } from 'react';

type PartWrapperProps = {
  extraClasses?: string;
  onOpen?: () => void;
  onClose?: () => void;
};

export const PartWrapper: FC<PropsWithChildren<PartWrapperProps>> = ({
  children,
  extraClasses,
  onOpen,
  onClose,
}) => {
  const handleKeyDown = ({ key }: React.KeyboardEvent) => {
    if (onClose && key === KEY_NAMES.ESCAPE) {
      onClose();
    }

    if (onOpen && (key === KEY_NAMES.ENTER || key === KEY_NAMES.SPACE)) {
      onOpen();
    }
  };

  return (
    <div className={extraClasses} onKeyDown={handleKeyDown} role="presentation">
      {children}
    </div>
  );
};
